import React from 'react';
import { Slide } from 'react-slideshow-image';

import { Link } from 'react-router-dom';

import 'react-slideshow-image/dist/styles.css'
import './PhotoSlider.css';

const PreviewSlider = ({ 
    col = 3,
    images = [],
    name = '',
    city = '',
    link = ''
}) => {

    const buttonStyle = {
        width: "30px",
        background: 'none',
        border: '0px',
        position:'absolute',
        left:0,
        top:'50%',
        opacity:'0'
    };

    const properties = {
        prevArrow: <button style={{ ...buttonStyle, 'transform':'rotateZ(180deg)' }}><svg width="15" height="15" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>,
        nextArrow: <button style={{ ...buttonStyle, 'left':'calc(100% - 30px)' }}><svg width="15" height="15" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>,
        autoplay: false,
        transitionDuration: 200
    }

    return (
        <div className={col === 1 ? "preview col1" : (col === 4 ? "preview col4" : "preview col3") }>
            <Slide {...properties}>
                <div className="each-slide-effect">
                    <div style={{ 'backgroundImage': `url(${images[0]})` }}></div>
                </div>
                <div className="each-slide-effect">
                    <div style={{ 'backgroundImage': `url(${images[1]})` }}></div>
                </div>
                <div className="each-slide-effect">
                    <div style={{ 'backgroundImage': `url(${images[2]})` }}></div>
                </div>
            </Slide>
            {
                name !== '' && city !== '' ?
                    <>
                        <div className="preview-info">
                            <Link to={link}>
                                <span>
                                    <div className="ps-name">
                                        {name}
                                    </div>
                                    <div className="ps-city">
                                        {city}
                                    </div>
                                </span>
                            </Link>
                        </div>
                    </>  : ''
            }
        </div>
    );
};

export default PreviewSlider;